<script setup>
import { useRoute } from 'vue-router'
const route = useRoute()

const lightGrayBgRoutes = ['account']
const whiteBlueBgRoutes = ['appointment', 'proposal', 'login', 'services-id']
const backgroundColor = computed(() => {
  if (lightGrayBgRoutes.some(name => route.name.startsWith(name)))
    return 'bg-white-500'

  if (whiteBlueBgRoutes.some(name => route.name.startsWith(name)))
    return 'bg-white-300'

  if (route.name.startsWith('services___')) // adding '__' to avoid background changes for subroutes.
    return 'bg-[#f2f4f7]' // darker white/gray color

  return ''
})
</script>
<template>
  <div :class="[backgroundColor, 'flex flex-col']">
    <div class="flex-1 flex flex-col min-h-dvh lg:h-full w-full">
      <NavigationBar />
      <div class="flex-grow flex flex-col">
        <NuxtPage />
      </div>
    </div>
    <Footer />
  </div>
</template>
